var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAircraftStands = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M15.09 15.876q-4.384-.042-9.99-.007l-1.671-.024-1.336-4.984 1.508-.031 1.512 2.03 5.14-.011-2.136-7.975 1.985-.01 4.995 7.979 5.49-.005q.623.006 1.067.46.444.45.45 1.072.004.62-.432 1.034-.434.415-1.052.431zM2.496 18.584h19.032V20.6H2.496z"
})));
export default SvgAircraftStands;